module.exports = new __parcel__URL__("sun.06e46477.png").toString();